var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v(_vm._s(_vm.IL)+" / "+_vm._s(_vm.ILCE))])])
}
var staticRenderFns = []

export { render, staticRenderFns }